
// import R3 from '@syman/burgeon-r3';
import globalstore from './customizeGlobal';
import strategyStore from './strategy.store';
import omsStore from './omsStore';

R3.store.registerModule('customize', globalstore);
R3.store.registerModule('strategy', strategyStore);
R3.store.registerModule('omsStore', omsStore);

export default R3.store;
